module.exports = __webpack_public_path__ + "img/nose.be5030ca.webp";